import {
  RevenueBreakdownSegmentDimension,
  RevenueBreakdownSegmentFieldsFragment,
  useCompanyRevenueBreakdownSectionQuery
} from 'generated/graphql';
import _ from 'lodash';
import { useMemo } from 'react';



export type ISegmentDataPoint = {
  value: string;
  year: number;
};

export type ISegment = {
  label: string;
  values: ISegmentDataPoint[];
};

export interface IData {
  years: number[];
  productSegments: Array<ISegment>;
  geographySegments: Array<ISegment>;
}

export function useQuery(listedCompanyId: string) {
  const tuple = useCompanyRevenueBreakdownSectionQuery({
    variables: {
      listedCompanyId
    }
  });

  return useMemo(
    () => {
      const segments = tuple.data?.listedCompany?.revenueBreakdownSegments ?? [];
      const allYears = __getYears(segments);

      const data: IData = {
        years: allYears,
        productSegments: __makeSegment(allYears, segments, 'product'),
        geographySegments: __makeSegment(allYears, segments, 'geography')
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



function __getYears(segments: RevenueBreakdownSegmentFieldsFragment[]) {
  let allYears = _.uniq(segments.flatMap((s) => s.values.map((v) => v.year)));

  if (allYears.length > 5) {
    allYears = allYears.slice(allYears.length - 5, allYears.length);
  }
  return _.sortBy(allYears);
}



function __makeSegment(displayYears: number[], fragments: RevenueBreakdownSegmentFieldsFragment[], dim: RevenueBreakdownSegmentDimension) {
  const segmentsForDimension = fragments.filter((f) => f.dimension === dim)
    .map((seg) => ({
      ...seg,
      values: seg.values.filter((val) => val.period === 'fy' && displayYears.includes(val.year))
    }));

  return segmentsForDimension.map((v) => {
    return ({
      label: v.label,
      values: v.values
        .map((val) => {
          return ({
            value: val.formattedValue,
            year: val.year
          });
        })
    });
  });

}
